import { render, staticRenderFns } from "./PlayerStatistics.vue?vue&type=template&id=6f9c5c8b&scoped=true"
import script from "./PlayerStatistics.vue?vue&type=script&lang=js"
export * from "./PlayerStatistics.vue?vue&type=script&lang=js"
import style0 from "./PlayerStatistics.vue?vue&type=style&index=0&id=6f9c5c8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9c5c8b",
  null
  
)

export default component.exports